import { Component, Input, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { NgForm } from '@angular/forms';
import { TimeOffApprovalFlow } from '@models/time-off-v3/time-off-approval-flow.model';

@Component({
    selector: 'app-approval-flow-form',
    templateUrl: './approval-flow.template.html',
    styles: [
        `
            form {
                --form-field-label-left-margin: 0;
            }
        `,
    ],
})
export class ApprovalFlowForm extends BaseForm {
    @Input() timeOffApprovalFlow: TimeOffApprovalFlow = new TimeOffApprovalFlow();
    @ViewChild('form') form: NgForm;
}
